import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import * as actions from '../action';
import * as c from '../constant';

const CMS_TYPE = 'MASKINGS';

const fields = [
  'LGU_PIN',

  'BPLS_E2E_BIN_NO',
  'BPLS_E2E_BIN_NO_REGEX',

  'BPLS_E2E_SEC_NO',
  'BPLS_E2E_SEC_NO_REGEX',
  'DEFAULT_BPLS_E2E_SEC_NO',

  'BPLS_E2E_DTI_NO',
  'BPLS_E2E_DTI_NO_REGEX',
  'DEFAULT_BPLS_E2E_DTI_NO',

  'BPLS_E2E_CDA_NO',
  'BPLS_E2E_CDA_NO_REGEX',
  'DEFAULT_BPLS_E2E_CDA_NO',

  'BPLS_E2E_TIN_NO',
  'BPLS_E2E_TIN_NO_PLACEHOLDER',
  'BPLS_E2E_TIN_NO_REGEX',

  'BPLS_E2E_PIN',
  'BPLS_E2E_PIN_PLACEHOLDER',
  'BPLS_E2E_PIN_REGEX',
  'DEFAULT_BPLS_E2E_PIN',

  'BPLS_E2E_PIN_19_DIGIT',
  'BPLS_E2E_PIN_19_DIGIT_PLACEHOLDER',
  'BPLS_E2E_PIN_19_DIGIT_REGEX',
  'DEFAULT_BPLS_E2E_PIN_19_DIGIT',

  'BPLS_E2E_TDN',
  'BPLS_E2E_TDN_PLACEHOLDER',
  'BPLS_E2E_TDN_REGEX',
  'DEFAULT_BPLS_E2E_TDN',

  'DEFAULT_CEDULA_SERIAL_NUMBER',
  'CEDULA_SERIAL_NUMBER',
  'CEDULA_SERIAL_NUMBER_REGEX',
  'CEDULA_INDIVIDUAL_SERIAL_NO_LABEL',
  'CEDULA_CORPORATE_SERIAL_NO_LABEL',
];

function Maskings({
  getList,
  createInput,
  item,
  setFormData,
  createHidden,
  create,
  update,
  formData,
  createCheckbox,
}) {
  useEffect(() => {
    getList({ type: CMS_TYPE });
  }, []);

  useEffect(() => {
    setFormData({
      ...JSON.parse(_.get(item, 'attributes.body') || '{}'),
      id: _.get(item, 'id'),
    });
  }, [item]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (_.get(formData, 'id')) {
      return update(_.get(formData, 'id'), {
        body: JSON.stringify(_.pick(formData, fields)),
      });
    }

    return create({
      body: JSON.stringify(_.pick(formData, fields)),
    });
  };

  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body p-4 p-lg-5">
        <form onSubmit={handleOnSubmit}>
          {createHidden({ key: 'id' }, { placeholder: '' })}

          <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-3">
            <div>
              <h5 className="mb-1 font-weight-bold">Masking Configuration</h5>
              <p className="mb-0 text-muted">
                Configure format masks and regex rules for BPLS and Cedula fields.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-6 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_BIN_NO', label: 'BPLS_E2E_BIN_NO' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_BPLS_E2E_BIN_NO'),}
              )}
            </div>
            <div className="col-6 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_BIN_NO_REGEX', label: 'BPLS_E2E_BIN_NO_REGEX' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_BPLS_E2E_BIN_NO'), }
              )}
            </div>
            <div className="col-12 form-group group-cms-color d-flex flex-row">
              {createCheckbox(
                { key: 'DEFAULT_BPLS_E2E_SEC_NO', label: 'Set Default SEC_NO:' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
              {_.get(formData, 'DEFAULT_BPLS_E2E_SEC_NO') && (
                <label className="form-label d-flex align-items-center m-0 mx-2">
                  (min of 5 characters, max of 20 characters, Alphanumeric)
                </label>
              )}
            </div>
            <div className="col-6 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_SEC_NO', label: 'BPLS_E2E_SEC_NO' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_BPLS_E2E_SEC_NO'), }
              )}
            </div>
            <div className="col-6 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_SEC_NO_REGEX', label: 'BPLS_E2E_SEC_NO_REGEX' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_BPLS_E2E_SEC_NO'), }
              )}
            </div>
            <div className="col-12 form-group group-cms-color d-flex flex-row">
              {createCheckbox(
                { key: 'DEFAULT_BPLS_E2E_DTI_NO', label: 'Set Default DTI_NO:' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
              {_.get(formData, 'DEFAULT_BPLS_E2E_DTI_NO') && (
                <label className="form-label d-flex align-items-center m-0 mx-2">
                  (min of 5 characters, max of 20 characters, Alphanumeric)
                </label>
              )}
            </div>
            <div className="col-6 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_DTI_NO', label: 'BPLS_E2E_DTI_NO' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_BPLS_E2E_DTI_NO'), }
              )}
            </div>
            <div className="col-6 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_DTI_NO_REGEX', label: 'BPLS_E2E_DTI_NO_REGEX' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_BPLS_E2E_DTI_NO'), }
              )}
            </div>
            <div className="col-12 form-group group-cms-color d-flex flex-row">
              {createCheckbox(
                { key: 'DEFAULT_BPLS_E2E_CDA_NO', label: 'Set Default CDA_NO:' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
              {_.get(formData, 'DEFAULT_BPLS_E2E_CDA_NO') && (
                <label className="form-label d-flex align-items-center m-0 mx-2">
                  (min of 5 characters, max of 20 characters, Alphanumeric)
                </label>
              )}
            </div>
            <div className="col-6 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_CDA_NO', label: 'BPLS_E2E_CDA_NO' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_BPLS_E2E_CDA_NO'), }
              )}
            </div>
            <div className="col-6 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_CDA_NO_REGEX', label: 'BPLS_E2E_CDA_NO_REGEX' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_BPLS_E2E_CDA_NO'), }
              )}
            </div>
            <div className="col-4 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_TIN_NO', label: 'BPLS_E2E_TIN_NO' },
                { required: false, type: 'text' }
              )}
            </div>
            <div className="col-4 form-group group-cms-color">
              {createInput(
                {
                  key: 'BPLS_E2E_TIN_NO_PLACEHOLDER',
                  label: 'BPLS_E2E_TIN_NO_PLACEHOLDER',
                },
                { required: false, type: 'text' }
              )}
            </div>
            <div className="col-4 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_TIN_NO_REGEX', label: 'BPLS_E2E_TIN_NO_REGEX' },
                { required: false, type: 'text' }
              )}
            </div>
            <div className="col-12 form-group group-cms-color d-flex flex-row">
              {createCheckbox(
                { key: 'DEFAULT_BPLS_E2E_PIN', label: 'Set Default PIN:' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
              {_.get(formData, 'DEFAULT_BPLS_E2E_PIN') && (
                <label className="form-label d-flex align-items-center m-0 mx-2">
                  (min of 5 characters, max of 20 characters, Alphanumeric)
                </label>
              )}
            </div>
            <div className="col-4 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_PIN', label: 'BPLS_E2E_PIN' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_BPLS_E2E_PIN'), }
              )}
            </div>
            <div className="col-4 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_PIN_PLACEHOLDER', label: 'BPLS_E2E_PIN_PLACEHOLDER' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_BPLS_E2E_PIN'), }
              )}
            </div>
            <div className="col-4 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_PIN_REGEX', label: 'BPLS_E2E_PIN_REGEX' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_BPLS_E2E_PIN'), }
              )}
            </div>
            <div className="col-12 form-group group-cms-color d-flex flex-row">
              {createCheckbox(
                { key: 'DEFAULT_BPLS_E2E_PIN_19_DIGIT', label: 'Set Default PIN 19 DIGIT:' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
              {_.get(formData, 'DEFAULT_BPLS_E2E_PIN_19_DIGIT') && (
                <label className="form-label d-flex align-items-center m-0 mx-2">
                  (min of 5 characters, max of 20 characters, Alphanumeric)
                </label>
              )}
            </div>
            <div className="col-4 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_PIN_19_DIGIT', label: 'BPLS_E2E_PIN_19_DIGIT' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_BPLS_E2E_PIN_19_DIGIT'), }
              )}
            </div>
            <div className="col-4 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_PIN_19_DIGIT_PLACEHOLDER', label: 'BPLS_E2E_PIN_19_DIGIT_PLACEHOLDER' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_BPLS_E2E_PIN_19_DIGIT'), }
              )}
            </div>
            <div className="col-4 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_PIN_19_DIGIT_REGEX', label: 'BPLS_E2E_PIN_19_DIGIT_REGEX' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_BPLS_E2E_PIN_19_DIGIT'), }
              )}
            </div>
            <div className="col-12 form-group group-cms-color d-flex flex-row">
              {createCheckbox(
                { key: 'DEFAULT_BPLS_E2E_TDN', label: 'Set Default TDN:' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
              {_.get(formData, 'DEFAULT_BPLS_E2E_TDN') && (
                <label className="form-label d-flex align-items-center m-0 mx-2">
                  (min of 5 characters, max of 20 characters, Alphanumeric)
                </label>
              )}
            </div>
            <div className="col-4 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_TDN', label: 'BPLS_E2E_TDN' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_BPLS_E2E_TDN'), }
              )}
            </div>
            <div className="col-4 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_TDN_PLACEHOLDER', label: 'BPLS_E2E_TDN_PLACEHOLDER' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_BPLS_E2E_TDN'), }
              )}
            </div>
            <div className="col-4 form-group group-cms-color">
              {createInput(
                { key: 'BPLS_E2E_TDN_REGEX', label: 'BPLS_E2E_TDN_REGEX' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_BPLS_E2E_TDN'), }
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-6 form-group group-cms-color">
              {createInput(
                { key: 'LGU_PIN', label: 'LGU_PIN' },
                { type: 'text' }
              )}
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-12 form-group group-cms-color">
              <b>CEDULA (CORPORATE & INDIVIDUAL)</b>
            </div>
            <div className="col-12 form-group group-cms-color d-flex flex-row">
              {createCheckbox(
                {
                  key: 'DEFAULT_CEDULA_SERIAL_NUMBER',
                  label: 'Set Default Serial Number:',
                },
                { className: 'd-flex align-items-center align-self-center' }
              )}
              {_.get(formData, 'DEFAULT_CEDULA_SERIAL_NUMBER') && (
                <label className="form-label d-flex align-items-center m-0 mx-2"> (9 digits)</label>
              )}
            </div>
            <div className="col-6 form-group group-cms-color">
              {createInput(
                { key: 'CEDULA_SERIAL_NUMBER', label: 'CEDULA_SERIAL_NUMBER' },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_CEDULA_SERIAL_NUMBER'), }
              )}
            </div>
            <div className="col-6 form-group group-cms-color">
              {createInput(
                {
                  key: 'CEDULA_SERIAL_NUMBER_REGEX',
                  label: 'CEDULA_SERIAL_NUMBER_REGEX',
                },
                { type: 'text', disabled: _.get(formData, 'DEFAULT_CEDULA_SERIAL_NUMBER'), }
              )}
            </div>
            <div className="col-6 form-group group-cms-color">
              {createInput(
                { key: 'CEDULA_INDIVIDUAL_SERIAL_NO_LABEL', label: 'CEDULA_INDIVIDUAL_SERIAL_NO_LABEL' },
                { type: 'text' }
              )}
            </div>
            <div className="col-6 form-group group-cms-color">
              {createInput(
                { key: 'CEDULA_CORPORATE_SERIAL_NO_LABEL', label: 'CEDULA_CORPORATE_SERIAL_NO_LABEL' },
                { type: 'text' }
              )}
            </div>
          </div>
          <div className="d-flex justify-content-center pt-2">
            <button
              type="submit"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary px-4 font-weight-bold"
            >
              <span className="font-weight-bold">
                Submit
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

Maskings.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createHidden: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  create: PropTypes.instanceOf(Function).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  createCheckbox: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: (_.get(api, `${c.GET_SETTINGS}.list`) || [])[0] || {},
});

const enhance = _.flowRight([
  withCmsForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(Maskings);
